/* cl-dropdown-menu: 7px vertical padding, min 140 / max 300, items #666. */
.menu {
  padding: 7px 0;
  min-width: 140px;
  max-width: 360px;
}

.profile {
  border-radius: var(--cl-menu-radius-profile);
  padding-bottom: 0;
}

.item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: var(--menu-row-height, 40px);
  padding: 0 20px;
  border: 0;
  background: transparent;
  color: var(--cl-dropdown-item-text);
  font: inherit;
  font-size: var(--cl-fs-base);
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.item:hover,
.item:focus-visible {
  background: var(--cl-dropdown-item-hover);
  color: var(--cl-dropdown-item-text);
  text-decoration: none;
  outline: none;
}

.active {
  color: var(--cl-text);
}

.danger,
.danger:hover,
.danger:focus-visible {
  color: var(--cl-danger);
}

.disabled,
.disabled:hover {
  color: var(--cl-text-placeholder);
  cursor: default;
  background: transparent;
}

.icon {
  display: inline-flex;
  color: var(--cl-nav-icon);
}

.header {
  display: flex;
  align-items: center;
  min-height: 38px;
  padding: 0 20px;
  color: var(--cl-text-muted);
  font-size: var(--cl-fs-xs);
  text-transform: uppercase;
}

.divider {
  margin: 0;
  border: 0;
  border-top: 1px solid var(--cl-border-light);
}
